// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider__166GF","vertical":"divider_vertical__NSfKU"};